export const GLOBAL_BANNER_DISMISSED_VERSION =
  "global_banner_dismissed_version";
